import ModalConfirmarAcao from '@/shared/components/modals/ModalProximaAcao';
import ModalFiltrosRelatorioMovimentacoes, { parametrosRelatorioMovimentacoes } from '@/modules/business/movimentacoes/components/ModalFiltrosMovimentacoes';
import ResumoTipoQuantidade from '../tables/MovimentacoesPorTipo.Table';
import { DataIso } from '@/shared/utils/datas';
import { EnumerateDefensores } from '@/modules/people/defensor.service';
import { ExportButton } from '../components/ExportButton';
import { GetDefensorias } from '@/modules/structure/defensoria/defensoria.service';
import { GetNucleos } from '@/modules/structure/nucleo/nucleo.service';
import { GetRelatorioMovimentacoes } from '../movimentacao.service';
import { MovimentacoesPorDefensorTable } from '../tables/MovimentacoesPorDefensor.Table';
import { MovimentacoesPorLocalTable } from '../tables/MovimentacoesPorLocal.Table';
import { ReadDefensoriaDto, ReadDefensorResponseDto, ReadNucleoDto, RMovimentoDto } from '@/api.types';
import { RelatorioMovimentacoesParametrosDto } from '@/api.types.extra';
import { RelatorioPDFMovimentacoes } from '../reports/MovimentacoesReport';
import { TabList } from '../components/TabList';
import { agruparPorDefensoriaNucleo, GrupoPorLocal } from '../components/agruparPorDefensoriaNucleo';
import { exportFromJsxToPdf } from '@/shared/utils/pdf';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { toast } from 'react-toastify';
import { useEffect, useState, useRef } from 'react';

export default function RelatorioMovimentacoesHeader() {
  const hoje = new Date(Date.now());

  const movimentacoesPorDefensorTableRef = useRef<HTMLDivElement>(null);
  const movimentacoesPorLocalTableRef = useRef<HTMLDivElement>(null);
  const resumoTipoQuantidadeTipoRef = useRef<HTMLDivElement>(null);
  const resumoTipoQuantidadeDefensorRef = useRef<HTMLDivElement>(null);
  const resumoTipoQuantidadeDefensoriaRef = useRef<HTMLDivElement>(null);

  const [showModelFilters, setshowModelFilters] = useState(false);
  const [modalConfirmacao, setModalConfirmacao] = useState(false)

  const [loaded, setLoaded] = useState(false);
  const [imprimindo, setImprimindo] = useState(false);

  const [inicio, setInicio] = useState(DataIso(new Date(hoje.getFullYear(), hoje.getMonth(), 1)));
  const [fim, setFim] = useState(DataIso(new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0)));
  const [ref, setRef] = useState(true);
  const [civel, setCivel] = useState(true);
  const [criminal, setCriminal] = useState(true);
  const [tipoId, setTipoId] = useState<number[]>([]);

  const [defensores, setDefensores] = useState<ReadDefensorResponseDto[]>();
  const [defensorias, setDefensorias] = useState<ReadDefensoriaDto[]>();
  const [nucleos, setNucleos] = useState<ReadNucleoDto[]>();

  const [defensorId, setDefensorId] = useState<number>(0);
  const [defensoriaId, setDefensoriaId] = useState<number>(0);
  const [nucleoId, setNucleoId] = useState<number>(0);

  const [dados, setDados] = useState<RMovimentoDto[]>([]);
  const [dadosAgrupadosPorLocal, setDadosAgrupadosPorLocal] = useState<GrupoPorLocal[]>([]);

  const handleBuscar = (params: parametrosRelatorioMovimentacoes) => {
    setInicio(params.inicio as string);
    setFim(params.fim as string);
    setRef(params.ref as boolean);
    setCivel(params.civel);
    setCriminal(params.criminal);
    setDefensorId(params.defensor);
    setDefensoriaId(params.defensoria);
    setNucleoId(params.nucleo);
    setTipoId(params.tipos);
  };

  // Carrega filtros.
  useEffect(() => {
    Promise.all([
      EnumerateDefensores(0, 1000).then((result) => {
        setDefensores(result.objects);
      }),
      GetDefensorias(0, 1000).then((result) => {
        setDefensorias(result.objects);
      }),
      GetNucleos(0, 1000).then((result) => {
        setNucleos(result.objects);
      }),
    ])
      .then(() => setLoaded(true))
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  // Monta relatório.
  useEffect(() => {
    const i = DataIso(inicio);
    const f = DataIso(fim);
    if (!i || !f)
      return;

    const queryString = tipoId.map((id) => `tipos=${id}`).join('&');

    const filtros: RelatorioMovimentacoesParametrosDto = {
      path: {
        inicio: i,
        fim: f,
        ref: ref,
      },
      query: {
        defensor: defensorId!,
        defensoria: defensoriaId,
        nucleo: nucleoId,
        civel,
        criminal,
        // @ts-expect-error property unknow
        tipos: queryString,
      }
    };

    GetRelatorioMovimentacoes(filtros)
      .then((res) => {
        setDados(res)
        setDadosAgrupadosPorLocal(agruparPorDefensoriaNucleo(res))
      })
      .catch((error) =>
        toast.error(String(error))
      )

  }, [defensorId, defensoriaId, nucleoId, inicio, fim, ref, civel, criminal, tipoId]);

  function printJsxToPdf(printResumoDefensoria: boolean, printResumoDefensor: boolean, printResumoTipo: boolean, printResumoDefensoriaAgrupado: boolean, printResumoDefensoriaDetalhado: boolean, printResumoDefensorDetalhado: boolean) {
    setImprimindo(true);
    try {
      exportFromJsxToPdf(<RelatorioPDFMovimentacoes
        dados={dados}
        dadosAgrupadosPorLocal={dadosAgrupadosPorLocal}
        parametros={{ inicio, fim, ref, civel, criminal, defensor: defensorId, defensoria: defensoriaId, nucleo: nucleoId, tipos: tipoId }}
        printResumoDefensoria={printResumoDefensoria}
        printResumoDefensor={printResumoDefensor}
        printResumoTipo={printResumoTipo}
        printResumoDefensoriaAgrupado={printResumoDefensoriaAgrupado}
        printResumoDefensoriaDetalhado={printResumoDefensoriaDetalhado}
        printResumoDefensorDetalhado={printResumoDefensorDetalhado}
      />);
    } catch (error) {
      console.error(error)
    } finally {
      setImprimindo(false);
    }
  }

  function getHeaders() {
    const di = new Date(inicio + "T00:00:00");
    const df = new Date(fim + "T00:00:00");

    return dados ?
      [
        `Relatórios ${ref ? 'referentes a: ' : 'recebidos entre: '} ${format(di, 'dd/MM/yyyy', { locale: ptBR })} a ${format(df, 'dd/MM/yyyy', { locale: ptBR })}`,
      ] : []
  }

  return (
    <div className="row">
      <div className="col-md-8 d-print-none">
        <h3 className="pt-4">Relatório de Movimentações</h3>
        <span className="blockquote-footer pb-4 text-end">
          Tabela de movimentações por defensor.
        </span>
      </div>

      <div className="col-md-4 d-print-none ">
        <br />

        <button
          className="btn btn-outline-secondary float-end ms-4"
          title="Cuidado, muitos dados podem travar a página."
          disabled={imprimindo}
          onClick={() => setModalConfirmacao(true)}
        >
          PDF Completo
        </button>

        <button className="btn btn-outline-success float-end" title="Filtros para o relatório de movimentações" onClick={() => { setshowModelFilters(true); }}>
          Gerar Relatório
        </button>
      </div>
      <hr className="pb-4 d-print-none" />

      {loaded && (
        <ModalFiltrosRelatorioMovimentacoes
          show={showModelFilters}
          handleHide={() => setshowModelFilters(false)}
          defensores={defensores!}
          defensorias={defensorias!}
          nucleos={nucleos!}
          handleBuscar={handleBuscar}
          valoresAtuais={{
            inicio,
            fim,
            ref,
            civel,
            criminal,
            defensor: defensorId,
            defensoria: defensoriaId,
            nucleo: nucleoId,
            tipos: tipoId,
          }}
        />
      )}

      <>
        <TabList />

        <div className="row" id="conteudo">
          <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane active" id="pills-rdefensor" role="tabpanel" aria-labelledby="pills-rdefensor-tab">
              {dados &&
                <>
                  <ExportButton
                    imprimindo={imprimindo}
                    htmlTableId='movimentacoesPorDefensorTable'
                    htmlHeaders={getHeaders()}
                    orientation='l'
                    htmlRef={movimentacoesPorDefensorTableRef}
                    printJsxToPdf={() => printJsxToPdf(false, false, false, false, false, true)} />
                  <div ref={movimentacoesPorDefensorTableRef}>
                    {getHeaders()}
                    <MovimentacoesPorDefensorTable dados={dados} />
                  </div>
                </>
              }
            </div>
            <div className="tab-pane " id="pills-rdefensoria" role="tabpanel" aria-labelledby="pills-rdefensoria-tab">
              {dados && <>
                <ExportButton
                  imprimindo={imprimindo}
                  htmlTableId='movimentacoesPorLocalTable'
                  htmlHeaders={getHeaders()}
                  htmlRef={movimentacoesPorLocalTableRef}
                  printJsxToPdf={() => printJsxToPdf(false, false, false, true, false, false)} />
                <div ref={movimentacoesPorLocalTableRef}>
                  {getHeaders()}
                  <MovimentacoesPorLocalTable dados={dados} />
                </div>
              </>}
            </div>
            <div className="tab-pane" id="pills-tipo" role="tabpanel" aria-labelledby="pills-tipo-tab">
              {dados && <>
                <ExportButton
                  imprimindo={imprimindo}
                  htmlTableId='resumoTipoQuantidadeTipo'
                  htmlHeaders={getHeaders()}
                  htmlRef={resumoTipoQuantidadeTipoRef}
                  printJsxToPdf={() => printJsxToPdf(false, false, true, false, false, false)} />
                <div ref={resumoTipoQuantidadeTipoRef}>
                  {getHeaders()}
                  <ResumoTipoQuantidade dados={dados} agrupamento='tipo' htmlTableId='resumoTipoQuantidadeTipo' />
                </div>
              </>
              }
            </div>
            <div className="tab-pane" id="pills-defensor" role="tabpanel" aria-labelledby="pills-defensor-tab">
              {dados && <>
                <ExportButton
                  imprimindo={imprimindo}
                  htmlTableId='resumoTipoQuantidadeDefensor'
                  htmlHeaders={getHeaders()}
                  htmlRef={resumoTipoQuantidadeDefensorRef}
                  printJsxToPdf={() => printJsxToPdf(false, true, false, false, false, false)} />
                <div ref={resumoTipoQuantidadeDefensorRef}>
                  {getHeaders()}
                  <ResumoTipoQuantidade dados={dados} agrupamento='defensor' htmlTableId='resumoTipoQuantidadeDefensor' />
                </div>
              </>
              }
            </div>
            <div className="tab-pane" id="pills-defensoria" role="tabpanel" aria-labelledby="pills-defensoria-tab">
              {dados && <>
                <ExportButton
                  imprimindo={imprimindo}
                  htmlTableId='resumoTipoQuantidadeDefensoria'
                  htmlHeaders={getHeaders()}
                  htmlRef={resumoTipoQuantidadeDefensoriaRef}
                  printJsxToPdf={() => printJsxToPdf(true, false, false, false, false, false)} />

                <div ref={resumoTipoQuantidadeDefensoriaRef}>
                  {getHeaders()}
                  <ResumoTipoQuantidade dados={dados} agrupamento='defensoria' htmlTableId='resumoTipoQuantidadeDefensoria' />
                </div>
              </>
              }
            </div>
          </div>
        </div>
      </>
      <ModalConfirmarAcao
        show={modalConfirmacao}
        handleHide={() => { setModalConfirmacao(false) }}
        tituloBotaoPrincipal="Gerar PDF"
        tituloDaCaixaDeTexto="Gerar PDF?"
        corpoDaCaixaDeTexto="Criar um documento PDF para essas informações?"
        handleAcaoPrincipal={() => printJsxToPdf(true, true, true, true, false, true)}
      />
    </div>
  );
}


